module.exports = __webpack_public_path__ + "static/media/merch.5a2d94b1.svg";